import React from 'react';
export default function TextColor(props) {
    return React.createElement("span", { style: { color: props.color } }, props.children);
}
//# sourceMappingURL=textColor.js.map